/*!

 =========================================================
 * Vue Light Bootstrap Dashboard - v2.0.0 (Bootstrap 4)
 =========================================================

 * Product Page: http://www.creative-tim.com/product/light-bootstrap-dashboard
 * Copyright 2019 Creative Tim (http://www.creative-tim.com)
 * Licensed under MIT (https://github.com/creativetimofficial/light-bootstrap-dashboard/blob/master/LICENSE.md)

 =========================================================

 * The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

 */
import Vue from 'vue';
import VueRouter from 'vue-router';
import App from './App.vue';
import CytoScriba from './cyto-scriba-main';
import './registerServiceWorker';
import './services/FirebaseService';
import { router } from './routes/router';
import { firebase } from './services/FirebaseService';
import { notificationService } from './services/NotificationsService';
import vuetify from './plugins/vuetify';
import { doc, getDoc, getFirestore, setDoc } from 'firebase/firestore';
import { settings, settingsSubject$, updateSettings } from './services/settings.util';

// plugin setup
Vue.use(VueRouter);
Vue.use(CytoScriba);

/* eslint-disable no-new */
const vm = new Vue({
  el: '#app',
  render: h => h(App),
  vuetify,
  router,
  provide: {
    settings: settings,
  },
});

// route to login if not routed
firebase.user$.subscribe(async (user) => {
  if (user === null) {
    if (!router.currentRoute.path.startsWith('/login')) {
      await router.push('/login');
    }
  } else if (!user.email.endsWith('@cytoreason.com')) {
    notificationService.error(`This app can only be used by users under <b>cytoreason.com</b> domain. <div>Please log in using your using your cytoreason.com user.</div>`);
    await firebase.auth.signOut();
  } else {
    notificationService.info(`Welcome ${user.displayName}`);
    const db = getFirestore();
    const userRef = doc(db, 'users', user.uid);
    await setDoc(userRef, {
      email: user.email,
      displayName: user.displayName,
      photoURL: user.photoURL,
      lastLogin: new Date(),
    }, { merge: true });
    const loadedUser = (await getDoc(userRef)).data();
    updateSettings({ admin: loadedUser.admin, loaded: true });
  }
});
